var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isShow && _setup.data)?_c('div',{staticClass:"node-config-wrap"},[(_setup.showObj.remark)?_c('p',{staticClass:"remark"},[_vm._v(_vm._s(_setup.showObj.remark))]):_vm._e(),(_setup.showObj.admin_remark)?_c('p',{staticClass:"remark"},[_vm._v(_vm._s(_setup.showObj.admin_remark))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }